import React from "react";
import "./DefaultScreen.css";
import WelcomeNameContainer from "./WelcomeNameContainer";

const DefaultScreen = () => {
 return (
  <>
   <div className="landing-page-container">
    <WelcomeNameContainer />
    <div className="landing-page-wrap">
     <img
      src={process.env.PUBLIC_URL + "/Images/comms_icon.png"}
      className="comms_icon"
     />
     <p className="landing-page-wrap-content">Create Faster, Communicate Better</p>
     {/* <p style={{ fontSize: "14px", marginTop: "7px" }}>
            Lorem ipsum dolor sit amet, consecteur adipiscing elit, sed do
            eiusmod tempor
          </p> */}
    </div>
   </div>
  </>
 );
};

export default DefaultScreen;
